import ErrorContainer from '@app/containers/ErrorContainer';

export default ErrorContainer;
